var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"b-icon",style:({ color: _vm.color, ..._vm.$attrs.style }),attrs:{"aria-hidden":"true","width":_vm.size,"height":_vm.size}},[_c('use',{attrs:{"xlink:href":_vm.icon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }